import { graphql } from '@/gql'

export const EditCompanyRecruiterCustomFieldValuesQuery = graphql(/* GraphQL */ `
  query EditCompanyRecruiterCustomFieldValuesQuery($companyRecruiterId: ID!) {
    companyRecruiter(id: $companyRecruiterId) {
      id
      customFieldValues {
        ...CustomFieldValuesView
        ...FieldableFormCustomFieldValue
      }
    }
  }
`)
